export const iconFontAwesomeTextformattingUnderline = (
	<i className="fa-solid fa-underline"></i>
);
